var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module"},[_c('div',{staticClass:"module__title"}),_c('div',{staticClass:"module__content"},[_c('image-swiper',{attrs:{"swiperList":_vm.swiperList}}),_c('news-list',{attrs:{"news":_vm.news}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }